import { HoldAndSpinSymbolSchema } from "ags/integration/schema/ags-spin-response-schema";
import slotDefinition from "slotworks/model/slot-definition";

export function getReelIndexFromCoordinate(symbol: HoldAndSpinSymbolSchema): number {
    const x = symbol.coordinate[0] * slotDefinition.matrixGrid[0];
    const y = symbol.coordinate[1];
    return x + y;
}
